<template>
  <v-stepper
      v-model="currentStep"
      vertical
      non-linear
      height="auto">
    <template v-for="stepItem in stepsParamArray">
      <v-stepper-step
          :key="`step-${stepItem.stepNumber}`"
          :complete="currentStep > stepItem.stepNumber"
          :step="stepItem.stepNumber">
        {{ stepItem.stepTitle }}
        <small class="text-orang-darken-2">
          {{ stepItem.stepTip }}
        </small>
      </v-stepper-step>
      <v-stepper-content
          :key="`content-${stepItem.stepNumber}`"
          :class="currentStep===stepItem.stepNumber
            ? 'otc-stepper-content-active'
            : ''"
          :step="stepItem.stepNumber">
        <v-card
            v-if="currentStep===stepItem.stepNumber"
            color="grey lighten-1"
            class="mb-5">
          <v-card-text>
            <slot
                :name="`main-${stepItem.stepNumber}`"
                :step="stepItem.stepNumber" />
            <v-row v-if="loading || !!generalError || !!stepItem.successText">
              <v-col>
                <v-progress-linear
                    :active="loading"
                    color="loader"
                    class="my-2"
                    indeterminate
                    height="8" />
                <general-error v-if="!!generalError" />
                <v-alert
                    v-if="!!stepItem.successText"
                    class="text-center"
                    type="success"
                    :value="success">
                  {{ stepItem.successText }}
                </v-alert>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn
                v-if="!!stepItem.toPrevStep"
                :id="`backBtn-${stepItem.stepNumber}`"
                class="ml-2 mr-1"
                color="primary"
                @click.stop="stepItem.toPrevStep(currentStep)">
              {{ $t('Назад') }}
            </v-btn>
            <slot
                v-if="currentStep===stepItem.stepNumber"
                :name="`buttons-${stepItem.stepNumber}`"
                :step="stepItem.stepNumber" />
            <v-btn
                v-if="!!stepItem.toNextStep"
                :id="`forwardBtn-${stepItem.stepNumber}`"
                class="mx-1"
                color="primary"
                :disabled="disabledForwardBtn || loading"
                @click.stop="stepItem.toNextStep(currentStep)">
              {{ $t('Продолжить') }}
            </v-btn>
            <v-btn
                v-if="!!stepItem.cancel"
                :id="`cancelBtn-${stepItem.stepNumber}`"
                class="ml-1 mr-2"
                color="primary"
                @click.stop="stepItem.cancel">
              {{ $t(stepItem.toNextStep
                ? 'Отмена'
                : 'Выход из мастера') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-stepper-content>
    </template>
  </v-stepper>
</template>

<style scoped>
  .text-orang-darken-2 {
    color: var(--v-info-base)!important;
  }

  .otc-stepper-content-active::v-deep .v-stepper__wrapper {
    height: auto !important;
  }
</style>

<script>
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  export default {
    components: {
      GeneralError
    },
    props: {
      value: {
        type: Number,
        required: true
      },
      stepsParamArray: {
        type: Array,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      },
      disabledForwardBtn: {
        type: Boolean,
        default: false
      },
      success: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        currentStep: 1
      }
    },
    watch: {
      value: {
        immediate: true,
        handler: function (newVal, oldVal) {
          if (newVal !== this.currentStep) {
            this.currentStep = newVal
            // this.$emit('input', newVal)
          }
        }
      }
    }
  }
</script>
